<script>
  export let pic;
  export let name;
  export let timeLabitCode;
  export let folderLabitCode;
  export let address;
  export let city;
  export let country;
  export let area;
  export let status;
  export let onClick;
</script>

<style>
  div.content {
    width: 100%;
    display: flex;
    padding-top: 5px;
    padding-bottom: 5px;
    color: var(--labit-card-gray);
  }

  div.noActive {
    color: var(--labit-text-lightgray) !important;
  }

  div.column1 {
    width: 7%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  div.column1 img {
    max-width: 58px;
    max-height: 38px;
  }

  div.column2 {
    width: 25%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 17px;
    font-weight: bold;
  }

  div.column3 {
    width: 13%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
  }

  div.column4 {
    width: 15%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
  }

  div.column5_1 {
    width: 9%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
  }

  div.column5_2 {
    width: 8%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
  }

  div.column6 {
    width: 6%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
  }

  div.column7 {
    width: 4%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  div.column7 img {
    width: 40%;
    opacity: 1;
    cursor: pointer;
  }

  /* Animations */

  div.content {
    transition: background-color 0.5s linear 0s;
  }

  div.content:hover {
    background-color: lightgray;
  }

  div.column7 img {
    transition: opacity 0.5s linear 0s;
  }

  div.column7 img:hover {
    opacity: 0.5;
  }
</style>

<div class="content {status ? '' : 'noActive'}">
  <div class="column1">
    <img
      src={pic !== '' ? pic : '/images/no_pic.svg'}
      alt="Project Pic"
      onerror="this.src='/images/no_pic.svg';" />
  </div>
  <div class="column2">
    <span>{name}</span>
  </div>
  <div class="column3">
    <span>{timeLabitCode}</span>
  </div>
  <div class="column3">
    <span>{folderLabitCode}</span>
  </div>
  <div class="column4">
    <span>{address}</span>
  </div>
  <div class="column5_1">
    <span>{city}</span>
  </div>
  <div class="column5_2">
    <span>{country}</span>
  </div>
  <div class="column6">
    <span>{area}</span>
  </div>
  <!--<div class="column6">
    <span>{status ? 'Active' : 'No Active'}</span>
  </div>-->
  <div class="column7">
    <img
      class="opcionesDots"
      src="/images/dots.svg"
      alt="Opciones"
      on:click={onClick} />
  </div>
</div>
